document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector(".testimonials-swiper");
  if (!swiperContainer) return;

  const swiper = new Swiper(".testimonials-swiper", {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    centeredSlides: true,
    loop: true,
    pagination: { el: ".swiper-pagination", type: "progressbar" },
    centeredSlidesBounds: true,
    spaceBetween: 20,
    watchOverflow: true,
    mousewheel: { forceToAxis: true },
    keyboard: { enabled: true, onlyInViewport: true },
    breakpoints: { 1024: { spaceBetween: 40 } },
  });

  // --- helpers (keep in same scope as swiper) ---
  const players = new WeakMap();
  let activePlayer = null;
  let vimeoApiPromise = null;

  function loadVimeoApiOnce() {
    if (window.Vimeo && window.Vimeo.Player) return Promise.resolve();
    if (vimeoApiPromise) return vimeoApiPromise;

    vimeoApiPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://player.vimeo.com/api/player.js";
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });

    return vimeoApiPromise;
  }

  function resetAllMuteButtons() {
    document.querySelectorAll(".js-unmute-button").forEach((btn) => {
      const muteIcon = btn.querySelector(".icon-speaker-x-mark");
      const unmuteIcon = btn.querySelector(".icon-speaker-wave");
      if (muteIcon) muteIcon.style.display = "block";
      if (unmuteIcon) unmuteIcon.style.display = "none";
      btn.setAttribute("aria-label", "Unmute video");
    });
  }

  function hydrateIframe(iframe) {
    if (!iframe) return false;
    if (iframe.src) return true;
    const ds = iframe.dataset.src;
    if (!ds) return false;
    iframe.src = ds;
    iframe.removeAttribute("data-src");
    return true;
  }

  async function playActiveSlideVideo() {
    // pause previous active player
    if (activePlayer) {
      try {
        await activePlayer.pause();
      } catch (e) {}
      activePlayer = null;
    }

    resetAllMuteButtons();

    const activeSlide = swiper.slides[swiper.activeIndex];
    const iframe = activeSlide?.querySelector(
      ".testimonial-video .vimeo-iframe",
    );
    if (!iframe) return;

    // set src only now
    hydrateIframe(iframe);

    await loadVimeoApiOnce();

    let player = players.get(iframe);
    if (!player) {
      player = new Vimeo.Player(iframe);
      players.set(iframe, player);
    }

    activePlayer = player;

    try {
      await player.ready();
      await player.setMuted(true);
      await player.play();
    } catch (e) {
      // ignore autoplay restrictions etc.
    }
  }

  // initial
  setTimeout(playActiveSlideVideo, 0);
  swiper.on("slideChange", playActiveSlideVideo);

  // unmute click (delegation)
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-unmute-button");
    if (!btn) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    const iframe = activeSlide?.querySelector(
      ".testimonial-video .vimeo-iframe",
    );
    if (!iframe) return;

    const player = players.get(iframe);
    if (!player) return;

    const muteIcon = btn.querySelector(".icon-speaker-x-mark");
    const unmuteIcon = btn.querySelector(".icon-speaker-wave");

    try {
      const isMuted = await player.getMuted();
      if (isMuted) {
        await player.setMuted(false);
        if (muteIcon) muteIcon.style.display = "none";
        if (unmuteIcon) unmuteIcon.style.display = "block";
        btn.setAttribute("aria-label", "Mute video");
      } else {
        await player.setMuted(true);
        if (muteIcon) muteIcon.style.display = "block";
        if (unmuteIcon) unmuteIcon.style.display = "none";
        btn.setAttribute("aria-label", "Unmute video");
      }
    } catch (err) {}
  });
});
